import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { DiceTest } from './DiceTest';
import { AuthGuard } from './components/auth/AuthGuard';
import { ThemeProvider } from './themes/ThemeProvider';

// Use ?dice-test in URL to show standalone dice tester
const showDiceTest = window.location.search.includes('dice-test');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      {showDiceTest ? (
        <DiceTest />
      ) : (
        <AuthGuard>
          <App />
        </AuthGuard>
      )}
    </ThemeProvider>
  </React.StrictMode>
);
